import React from "react";
import { Box, Button, Tooltip, Typography } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { AUDIT_TEMPLATE_URL } from "../constants/constants";

export const TemplateDownloadHeader: React.FC = () => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, mb: 2 }}>
      <Button
        size="small"
        variant="contained"
        startIcon={<FileDownloadOutlinedIcon />}
        onClick={() => window.open(AUDIT_TEMPLATE_URL, "_blank", "noopener,noreferrer")}
        sx={{
          backgroundColor: "#eed076",
          color: "#222222",
          fontWeight: 600,
          borderRadius: "20px",
          textTransform: "none",
          px: 2.5,
          py: 0.5,
          boxShadow: "none",
          "&:hover": {
            backgroundColor: "#e3c265",
            boxShadow: "none",
          },
        }}
      >
        Download sample template
      </Button>
      <Tooltip
        arrow
        placement="right"
        title={
          <Box sx={{ p: 0.5 }}>
            <Typography variant="caption" display="block" fontWeight={600} mb={0.5}>
              Official Textile Exchange Audit Data template
            </Typography>
            <Typography variant="caption" display="block">
              Opens the Textile Exchange Knowledge Center in a new tab. Download the blank Audit Data
              template, fill it in, then rename the file as AD_&lt;CB_Code&gt;_&lt;TE_ID&gt;_&lt;Audit Dates&gt;_&lt;Submission Date&gt;.xlsx
              and upload it here.
            </Typography>
          </Box>
        }
      >
        <InfoOutlinedIcon
          fontSize="small"
          sx={{ color: "text.secondary", cursor: "help" }}
          aria-label="About the sample template"
        />
      </Tooltip>
    </Box>
  );
};
